import React from "react";
import styled from "styled-components";

import Button from "./Button";
import * as T from "./Typography";
import colours from "../utils/colours";
import device from "../utils/device";

export default function Dialog(props) {
  return (
    <S.Container data-cy="dialog">
      <S.Dialog>
        <S.Title>
          <T.H3>{props.title}</T.H3>
        </S.Title>

        <S.Body>
          <T.CXL>{props.children}</T.CXL>
        </S.Body>

        <S.Actions>
          <S.ConfirmAction>
            <Button isWide onClick={props.onConfirmClick}>
              {props.confirmLabel}
            </Button>
          </S.ConfirmAction>

          {props.cancelLabel && props.onCancelClick && (
            <S.CancelAction>
              <Button isWide isSecondary onClick={props.onCancelClick}>
                {props.cancelLabel}
              </Button>
            </S.CancelAction>
          )}
        </S.Actions>
      </S.Dialog>
    </S.Container>
  );
}

const S = {};

S.Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.4);
  z-index: 9999;
  backdrop-filter: blur(3px);
`;

S.Dialog = styled.div`
  background-color: ${colours.shell};
  text-align: left;
  margin: 0 20px;
  padding: 30px;
  @media ${device.mobile} {
    width: 400px;
  }
`;

S.Title = styled.div``;

S.Body = styled.div`
  margin: 20px 0;
`;

S.Actions = styled.div`
  display: flex;
  width: 100%;
`;

S.ConfirmAction = styled.div`
  flex-grow: 1;
  margin-right: 10px;
`;

S.CancelAction = styled.div`
  flex-grow: 1;
  margin-left: 10px;
`;
